// Shared light/dark color helpers for the rail/panel/drawer navigation
// surfaces. Centralized so SidePanel.styled.js and NavMobileLayout.styled.js
// don't redeclare the same palette. Theme name is read from the
// styled-components theme prop (lightTheme / darkTheme).

const isLight = (props) => props.theme.name === 'light';
const pick = (light, dark) => (props) => isLight(props) ? light : dark;

// Surfaces shared between side panel and mobile drawer
export const panelBg = (props) =>
  isLight(props) ? props.theme.colors.white : '#1a1a2e';
export const panelBorder = pick(
  'rgba(0, 0, 0, 0.08)',
  'rgba(255, 255, 255, 0.1)'
);
export const subtleBorder = pick(
  'rgba(0, 0, 0, 0.06)',
  'rgba(255, 255, 255, 0.06)'
);
export const drawerDivider = pick(
  'rgba(0, 0, 0, 0.08)',
  'rgba(255, 255, 255, 0.08)'
);

// Shared text
export const titleText = pick('#1f2937', '#ffffff');
export const sectionLabel = pick('#64748b', '#7c8a9d');
export const itemHoverText = pick('#0f172a', '#ffffff');
export const subItemText = pick('#64748b', '#90a4ae');

// Side-panel-specific
export const panelItemText = (props) =>
  isLight(props) ? props.theme.colors.text.primary : '#b0bec5';
export const panelItemHoverBg = pick(
  'rgba(0, 0, 0, 0.05)',
  'rgba(255, 255, 255, 0.05)'
);
export const mutedItemText = pick('#94a3b8', '#475569');
export const mutedItemHoverText = pick('#475569', '#b0bec5');
export const mutedItemHoverBg = pick(
  'rgba(0, 0, 0, 0.03)',
  'rgba(255, 255, 255, 0.03)'
);
export const closeBtnBg = pick(
  'rgba(0, 0, 0, 0.04)',
  'rgba(255, 255, 255, 0.05)'
);
export const closeBtnBgHover = pick(
  'rgba(0, 0, 0, 0.08)',
  'rgba(255, 255, 255, 0.08)'
);
export const closeBtnBorder = pick(
  'rgba(0, 0, 0, 0.08)',
  'rgba(255, 255, 255, 0.1)'
);
export const closeBtnBorderHover = pick(
  'rgba(0, 0, 0, 0.15)',
  'rgba(255, 255, 255, 0.15)'
);
export const closeBtnColor = pick('#64748b', 'rgba(255, 255, 255, 0.5)');
export const subItemConnector = pick(
  'rgba(0, 0, 0, 0.12)',
  'rgba(255, 255, 255, 0.15)'
);
export const scrollbarThumb = pick(
  'rgba(0, 0, 0, 0.1)',
  'rgba(255, 255, 255, 0.1)'
);
export const scrollbarThumbHover = pick(
  'rgba(0, 0, 0, 0.2)',
  'rgba(255, 255, 255, 0.2)'
);

// Mobile-drawer-specific
export const drawerItemText = (props) =>
  isLight(props)
    ? props.theme.colors.text.primary
    : 'rgba(255, 255, 255, 0.65)';
export const drawerItemHoverBg = pick(
  'rgba(0, 0, 0, 0.04)',
  'rgba(255, 255, 255, 0.03)'
);
export const sectionHeaderText = pick('#475569', 'rgba(255, 255, 255, 0.75)');
export const sectionHeaderHoverBg = pick(
  'rgba(0, 0, 0, 0.05)',
  'rgba(255, 255, 255, 0.05)'
);
export const chevronColor = pick(
  'rgba(0, 0, 0, 0.4)',
  'rgba(255, 255, 255, 0.4)'
);
export const subGroupBg = pick('rgba(0, 0, 0, 0.04)', 'rgba(0, 0, 0, 0.15)');
export const itemButtonText = pick('#94a3b8', 'rgba(255, 255, 255, 0.35)');
export const itemButtonHoverText = pick('#64748b', 'rgba(255, 255, 255, 0.55)');
export const itemButtonHoverBg = pick(
  'rgba(0, 0, 0, 0.02)',
  'rgba(255, 255, 255, 0.02)'
);
export const groupTitleText = pick('#94a3b8', 'rgba(255, 255, 255, 0.3)');
export const footerText = pick('#475569', 'rgba(255, 255, 255, 0.65)');
export const avatarBg = pick(
  'rgba(0, 0, 0, 0.08)',
  'rgba(255, 255, 255, 0.15)'
);
export const avatarBorder = pick(
  'rgba(0, 0, 0, 0.15)',
  'rgba(255, 255, 255, 0.25)'
);
export const avatarText = pick('#1f2937', 'white');
